import React from 'react';

const FilterMakeIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8 17V12H12V17" stroke="#1F221F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7.5 6.5H12M7.5 9H12" stroke="#1F221F" strokeWidth="1.5" strokeLinecap="round" />
    <rect x="4" y="3" width="12" height="14" rx="0.2" stroke="#1F221F" strokeWidth="1.5" />
  </svg>
);

export default FilterMakeIcon;
